import * as math from '../math';
import LatLng from './latlng';

const empty = () => ({
    nw: LatLng.fromLatAndLng(0, 0),
    se: LatLng.fromLatAndLng(0, 0),
});

/**
 * Is p in bounds?
 * @sig isPointInBounds -> (LatLng, BoundingBox) -> Boolean
 */
const isPointInBounds = (p, boundingBox) => {
    const { n, w, s, e } = boundingBox;
    return math.isBetween(w, p.lng, e) && math.isBetween(s, p.lat, n);
};

export { empty, isPointInBounds };
